import VideosUploadScreen from './VideosUpload';

export default VideosUploadScreen;
